// extracted by mini-css-extract-plugin
export default {"MainHeader":"Header_MainHeader__9DtA1","navBookingBtn":"Header_navBookingBtn__pJ8t-","NavHeader":"Header_NavHeader__OtZmO","NavHeaderContainer":"Header_NavHeaderContainer__BFeNN"};